import { PEOPLE, type Assignee } from '../lib/types'

type Props = {
  value: Assignee
  onChange: (assignee: Assignee) => void
  size?: 'sm' | 'md'
}

/** Row of faces; the selected one is ringed. Used in the composer and detail panel. */
export function AssigneePicker({ value, onChange, size = 'sm' }: Props) {
  const dimension = size === 'sm' ? 'size-7' : 'size-9'

  return (
    <div role="radiogroup" aria-label="Assigned to" className="flex items-center gap-1">
      {PEOPLE.map((person) => {
        const selected = person.id === value
        return (
          <button
            key={person.id}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={person.name}
            title={person.name}
            onClick={() => onChange(person.id)}
            className={`rounded-full transition ${
              selected
                ? 'ring-2 ring-teal ring-offset-1'
                : 'opacity-70 grayscale hover:opacity-100 hover:grayscale-0 ring-1 ring-black/5'
            }`}
          >
            <img
              src={person.avatar}
              alt=""
              className={`${dimension} rounded-full object-cover`}
            />
          </button>
        )
      })}
    </div>
  )
}
